module.exports = __webpack_public_path__ + "static/brauchtdich_covid-plattform-logo-1c426c483bded1e1d40b6a9b73e9e121.jpg";